// extracted by mini-css-extract-plugin
export var active = "Footer-module--active--0bf35";
export var brand = "Footer-module--brand--c37ae";
export var colophon = "Footer-module--colophon--baff7";
export var copyright = "Footer-module--copyright--da484";
export var footer = "Footer-module--footer--d7e4b";
export var infos = "Footer-module--infos--7fc6c";
export var linksList = "Footer-module--linksList--771a8";
export var nav__title = "Footer-module--nav__title--5234f";
export var social = "Footer-module--social--3ea0c";
export var wrapper = "Footer-module--wrapper--43cc5";